import axios from 'axios'

//Default values
const state = {
    'types': {},
    'selectedType': ''
}

const mutations = {
    FILL_TYPES: (state, resp) => {
        state.types = resp;
    },
    SET_SELECTED_TYPE: (state, resp) => {
        state.selectedType = resp;
    },
}

const actions = {
    SAVE_CUSTOMER: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(process.env.VUE_APP_API_URL + 'customers', payload)
                .then((res) => {
                    return resolve(res);
                }).catch(error => {
                return reject(error.response.data);
            })
        })
    },
    GET_CUSTOMER: async (context, payload) => {
        return axios.get(process.env.VUE_APP_API_URL + 'customers/' + payload)
            .then((res) => {
                return res.data
            })
    },
    GET_CUSTOMERS: async ({rootState, commit}, payload) => {
        return axios.get(process.env.VUE_APP_API_URL + 'customers', {
            params: rootState.table.table.serverParams
        })
            .then((res) => {
                commit('FETCH_ITEMS', res.data)
            })
    },
    UPDATE_CUSTOMER: async (context, payload) => {
        return axios.put(process.env.VUE_APP_API_URL + 'customers/' + payload.id, payload)
            .then((res) => {
                return res.data
            })
    },
    DROPDOWN_CUSTOMER: async (context, payload) => {
        return axios.get(process.env.VUE_APP_API_URL + 'customers/dropdown?q=' + payload)
            .then((res) => {
                return res.data
            })
    },
    DROPDOWN_TYPES_CUSTOMER: async ({commit}, payload) => {
        return axios.get(process.env.VUE_APP_API_URL + 'customers/' + payload + '/component-types/dropdown')
            .then((res) => {
                // commit('FILL_TYPES',res.data);
                return res.data
            })
    },
    DELETE_CUSTOMER: async ({commit}, payload) => {
        return axios.delete(process.env.VUE_APP_API_URL + 'customers/' + payload.id, payload)
            .then((res) => {
                return res.data
            })
    },
}

const getters = {
    getTypes: state => state.types,
    getSelectedType: state => state.selectedType
}

export default {
    state,
    mutations,
    actions,
    getters
}
